import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReportsTableActionsWrapper = styled.div`
  display: flex;
`

export const LeftActions = styled.div`
  margin-right: ${Spacing.S16};
`

export const RightActions = styled.div`
  align-self: flex-end;
  margin-left: auto;
`
